import React from "react";
import styled from "styled-components";

export type LumenStripTone = "blocked" | "fail" | "warn";

export interface LumenStripSection {
  tone: LumenStripTone;
  eyebrow: string;
  lines: string[];
}

const TONES: Record<LumenStripTone, { border: string; eyebrowColor: string }> = {
  blocked: { border: "#F0728C", eyebrowColor: "#F5A0B2" },
  fail: { border: "#F0728C", eyebrowColor: "#F5A0B2" },
  warn: { border: "#C4B58F", eyebrowColor: "#DCC49C" },
};

const Strip = styled.div`
  background: #38335a;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 18px 26px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Rule = styled.div<{ $border: string }>`
  border-left: 3px solid ${({ $border }) => $border};
  padding-left: 16px;
`;

const Eyebrow = styled.div<{ $color: string }>`
  font: 600 11px "Work Sans", sans-serif;
  letter-spacing: 0.04em;
  color: ${({ $color }) => $color};
`;

const Body = styled.p`
  font: 300 13px/1.55 "Work Sans", sans-serif;
  color: #d6d2e6;
  margin: 9px 0 0;

  & + & {
    margin-top: 4px;
  }
`;

export const LumenBannerStrip = ({
  sections,
}: {
  sections: LumenStripSection[];
}) => (
  <Strip>
    {sections.map((s, i) => {
      const t = TONES[s.tone];
      return (
        <Rule key={`${s.eyebrow}-${i}`} $border={t.border}>
          <Eyebrow $color={t.eyebrowColor}>{s.eyebrow}</Eyebrow>
          {s.lines.map((line) => (
            <Body key={line}>{line}</Body>
          ))}
        </Rule>
      );
    })}
  </Strip>
);
